const expertiseColumns = [
  {
    header: 'Platform Expertise',
    items: ['iOS Development', 'Mobile Architecture', 'System Integration'],
  },
  {
    header: 'Technical Quality',
    items: [
      'Performance Tuning',
      'Code Quality Standards',
      'Reliability Engineering',
    ],
  },
  {
    header: 'Engineering Approach',
    items: [
      'Clean Architecture',
      'User-Centered Design',
      'Workflow Optimization',
    ],
  },
];

export default function ContactSection() {
  return (
    <section
      className="relative w-full bg-background-50 py-20 md:py-28 px-6 md:px-12 lg:px-20"
      aria-label="Contact information"
    >
      <div className="max-w-6xl mx-auto">
        <div className="flex flex-col lg:flex-row gap-14 lg:gap-20">
          <div className="flex-shrink-0 lg:w-2/5">
            <h2 className="font-heading text-3xl md:text-4xl lg:text-5xl font-bold text-foreground-950 leading-tight">
              Get in Touch
            </h2>
            <p className="mt-4 text-foreground-600 text-base leading-relaxed font-body max-w-sm">
              Reach out to discuss how we can help bring your vision to life
              with professional engineering expertise.
            </p>

            <div className="mt-10 space-y-5">
              <div>
                <span className="block font-label text-xs font-medium text-foreground-400 uppercase tracking-wider mb-3">
                  Contact Information
                </span>
                <div className="space-y-3 py-3 px-4 rounded-lg border border-background-200/80 bg-background-100/50">
                  <p className="text-foreground-800 text-sm leading-relaxed font-body">
                    <span className="text-foreground-500">Address:</span>{' '}
                    156 Cottingham St
                  </p>
                  <p className="text-foreground-800 text-sm leading-relaxed font-body">
                    <span className="text-foreground-500">City:</span> Toronto
                  </p>
                  <p className="text-foreground-800 text-sm leading-relaxed font-body">
                    <span className="text-foreground-500">Zip:</span> M4V 1C3
                  </p>
                  <p className="text-foreground-800 text-sm leading-relaxed font-body">
                    <span className="text-foreground-500">Country:</span> Canada
                  </p>
                  <div className="w-full h-px bg-background-200/80 my-1" />
                  <p className="text-foreground-800 text-sm leading-relaxed font-body">
                    <span className="text-foreground-500">Phone:</span>{' '}
                    +1 8254450155
                  </p>
                  <p className="text-foreground-800 text-sm leading-relaxed font-body">
                    <span className="text-foreground-500">Email:</span>{' '}
                    ceo@odnexora.com
                  </p>
                </div>
              </div>
            </div>
          </div>

          <div className="flex-1">
            <div className="grid grid-cols-1 sm:grid-cols-3 gap-8 md:gap-10">
              {expertiseColumns.map((col) => (
                <div key={col.header}>
                  <h3 className="font-heading text-sm font-semibold text-foreground-900 uppercase tracking-wider mb-5">
                    {col.header}
                  </h3>
                  <ul className="space-y-3">
                    {col.items.map((item) => (
                      <li
                        key={item}
                        className="text-foreground-600 text-sm font-body"
                      >
                        {item}
                      </li>
                    ))}
                  </ul>
                </div>
              ))}
            </div>

            <div className="mt-14 pt-8 border-t border-background-200/60">
              <p className="text-foreground-400 text-xs font-body">
                &copy; {new Date().getFullYear()} All rights reserved.
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}